<template>
  <b-container fluid class="position-relative" style="min-height: 100vh">
    <div v-if="isRefVisible" @click="closeRefs" class="close-ref"></div>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(sendToFts)" autocomplete="off">
        <b-tabs v-model="tabIndex" id="document-tabs" content-class="mt-3">
          <b-tab :active="i.active" v-for="i in tabs" :key="i.key" @click="closeRefs">
           <template #title>
             {{ i.name }}
             <b-button-close 
               @click="removeDoc(i.name)" 
               class="ml-3"
               v-if="!notForEdit && isTab(i.name)"></b-button-close>
           </template>
            <house-shipment-page
              v-if="i.name === 'Накладная'"
              ref="houseShipmentPage"
              :houseShipment="houseShipment"
              :notForEdit="notForEdit"
              @updateHouseShipment="savePackageInIdb()"
              @updateWbFields="updateWbFields($event)"
              @updatePassFields="updatePassFields($event)"
              :getValidationState="getValidationState"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </house-shipment-page>
            <goods-page
              v-if="i.name === 'Товары'"
              ref="goodsPage"
              :houseShipment="houseShipment"
              :notForEdit="notForEdit"
              @updateHouseShipment="savePackageInIdb()"
              :getValidationState="getValidationState">
            </goods-page>
            <passport-page v-if="i.name === 'Паспорт РФ'"
              ref="passportPage"
              :passport="passport"
              :houseShipment="houseShipment"
              :notForEdit="notForEdit"
              @updatePassport="savePackageInIdb()"
              @updateHsFields="updateHsFields($event)"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeDoc(i.name)"
              @setTabIndex="tabIndex = tabs.length-1"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </passport-page>
            <waybill-page v-if="i.name === 'Индивидуальная накладная'"
              ref="waybillPage"
              :waybill="waybill"
              :houseShipment="houseShipment"
              :notForEdit="notForEdit"
              @updateWaybill="savePackageInIdb()"
              @updateHsFields="updateHsFields($event)"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeWaybillPage()"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setTabIndex="tabIndex = tabs.length-1"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </waybill-page>
            <inventory-page v-if="i.name === 'Графические материалы'"
              ref="inventoryPage"
              :notForEdit="notForEdit"
              parentType="houseshipment"
              :freeBinaryDocs="freeBinaryDocs"
              @updateDocs="savePackageInIdb()"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeInventoryPage()"
              @setTabIndex="tabIndex = tabs.length-1"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </inventory-page>
            <air-waybill-page v-if="i.name === 'Авианакладная'"
              ref="airWaybillPage"
              :notForEdit="true"
              :airWaybill="airWaybill"
              @updateAirWaybill="savePackageInIdb()"
              :getValidationState="getValidationState"
              @removeInventoryTab="removeAirWaybillPage()"
              @setTabIndex="tabIndex = tabs.length-1"
              :targetInput="targetInput"
              @closeRefs="closeRefs"
              @setVisible="isRefVisible = $event"
              @setTarget="targetInput = $event">
            </air-waybill-page>
          </b-tab>
          <template #tabs-end>
            <b-nav-item-dropdown 
              v-if="!notForEdit && (!hasTab('Индивидуальная накладная') || !hasTab('Графические материалы') || !hasTab('Паспорт РФ') || !hasTab('Авианакладная'))" 
              text="+ Добавить документ" 
              no-caret
              toggle-class="border border-white rounded-0">
               <b-dropdown-item 
                  v-if="!hasTab('Паспорт РФ')" 
                  @click.prevent="addPassportPage">
                Паспорт РФ
               </b-dropdown-item>
               <b-dropdown-item 
                 v-if="!hasTab('Индивидуальная накладная')" 
                 @click.prevent="addWaybillPage">
                Индивидуальная накладная
               </b-dropdown-item>
               <b-dropdown-item 
                 v-if="!hasTab('Графические материалы')" 
                 @click.prevent="addInventoryPage">
                Графические материалы
               </b-dropdown-item>
               <b-dropdown-item 
                 v-if="!hasTab('Авианакладная')" 
                 @click.prevent="addAirWaybillPage">
                Авианакладная
               </b-dropdown-item>
            </b-nav-item-dropdown>
          </template>
        </b-tabs>
        <b-row class="mb-3 mt-7">
          <b-col xl="6" lg="12" md="12" sm="12" cols="12">
            <div class="d-md-flex d-lg-flex align-items-center">
              <span v-b-tooltip.hover
                    :title="((!TransportModeCode || !TransportDocumentNumber) && !notForEdit) ? 'Необходимо указать номер и код документа общей накладной' : notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                <b-button
                  variant="success"
                  @click="sendToPortal"
                  class="btn-action-success mr-3 mb-2"
                  :disabled="hasEmptyRequiredFields || notForEdit"
                  squared size="sm"
                >
                  Сохранить
                </b-button>
              </span>
              <span v-b-tooltip.hover :title="notForEdit ? 'В текущем статусе изменение пакета невозможно' : ''">
                <b-button
                  variant="success"
                  @click="scrollIfError"
                  class="btn-action-success mr-3 mb-2"
                  :disabled="notForEdit"
                  squared
                  size="sm"
                >
                Отправить&nbsp;в&nbsp;ФТС
              </b-button>
              </span>
              <div v-if="hasEmptyRequiredFields" class="mr-3 custom-invalid-feedback" style="height: 31px">
                Заполните обязательные поля на вкладках Накладная, Товары
              </div>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-modal ref="save-package-result-modal" @hidden="hideModal" hide-footer no-close-on-backdrop no-close-on-esc
             title="Данные успешно сохранены">
      <div class="d-block text-center">
        <span>Создана товарная партия №{{ $route.params.pid }}</span>
      </div>
      <b-button class="mt-3" variant="outline-primary" block @click="checkoutToEditHouseShipment">Продолжить работу
        с товарной партией
      </b-button>
      <b-button class="mt-2" variant="outline-success" block @click="() => $router.push('/ecr/house-shipment')">Перейти к
        списку товарных партий
      </b-button>
    </b-modal>
    <b-modal ref="get-packages-from-cache" hide-footer no-close-on-backdrop no-close-on-esc
             title="У вас есть несохраненные данные">
      <b-button class="mt-2" variant="primary" @click="$refs['get-packages-from-cache'].hide()" block>Отмена</b-button>
      <b-button class="mt-2" variant="outline-danger" @click="deletePackageFromIdb" block>Уйти с потерей данных
      </b-button>
    </b-modal>
  </b-container>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex'
  import HouseShipmentPage from './HouseShipmentPage'
  import GoodsPage from './HouseShipmentGoodsPage'
  import PassportPage from './PassportPage'
  import WaybillPage from './WaybillExpressIndividualPage'
  import InventoryPage from './InventoryPage'
  import AirWaybillPage from './AirWaybillPage'
  import idbapi from '../../../idbapi/idb.js'
  import moment from 'moment'

  export default {
    name: "HouseShipmentForm",
    components: {
      HouseShipmentPage,
      GoodsPage,
      PassportPage,
      WaybillPage,
      InventoryPage,
      AirWaybillPage
    },
    data () {
      return {
        TransportModeCode: null,
        TransportDocumentNumber: null,
        HouseWaybillModeCode: null,
        HouseWaybillDocumentNumber: null,
        ConsignorName: null,
        ConsigneeName: null,
        showAllDeclineReasons: false,
        tabIndex: 0,
        tabs: [
          { name: 'Накладная', key: Math.random() },
          { name: 'Товары', key: Math.random() }
        ],
        showConfirmModal: false,
        notForEdit: false,
        idbPackageId: 1,
        preventedRouteTo: null,
        targetInput: null,
        isRefVisible: false,
        loadFromDtModalShow: false,
        docsLoading: false
      }
    },
    watch: {
      '$route' (val, oldVal) {
        if (val.name === 'AddHouseShipment') {
          this.$nextTick(() => {
            this.$refs.houseShipmentPage[0].resetFormData()
            this.$refs.goodsPage[0].resetFormData()
            if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
              this.$refs.waybillPage[0].resetFormData()
            }
            if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
              this.$refs.inventoryPage[0].resetFormData()
            }
            if (this.$refs.passportPage && this.$refs.passportPage.length > 0) {
              this.$refs.passportPage[0].resetFormData()
            }
            if (this.$refs.airWaybillPage && this.$refs.airWaybillPage.length > 0) {
              this.$refs.airWaybillPage[0].resetFormData()
            }
          })
          this.setPackage(null)
          this.setPackagePid(null)
          this.setPackageChainid(null)
          this.setPackageStatus(null)
          this.setPackageDocumentsList(null)
          this.setWaybill(null)
          this.setPasssport(null)
          this.setFreeBinaryDocs(null)
          this.notForEdit = false
        }
        if (val.name === 'EditHouseShipment' && oldVal.name !== 'EditHouseShipment' && oldVal.name !== 'AddHouseShipment') {
          this.getPackageDocumentsList(val.params.pid).then(
            () => {
              if (this.isNewPackageInChain()) {
                this.setPackagePid({ pid: null })
              }
              this.getDocuments()
            },
            (error) => {
              console.log(error)
            }
          )
        }
        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
      },
    },
    beforeRouteLeave (to, from, next) {
      this.preventedRouteTo = to.name
      if ((to.meta.prevented === false) || ((from.name === 'EditHouseShipment') && (to.name !== 'Login'))) {
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              next(false)
              this.$refs['get-packages-from-cache'].show()
            } else {
              next()
            }
          }
        )
      } else {
        next()
      }
    },
    mounted () {
      if (this.$route.name === 'AddHouseShipment') {
        this.setPackageDocumentsList(null)
        idbapi.getPackageData().then(
          (documents) => {
            if (documents && (documents.length > 0)) {
              if (documents[0].waybill !== null) {
                this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
              }
              if (documents[0].freeBinaryDocs !== null) {
                this.tabs.push({ name: 'Графические материалы', key: Math.random() })
              }
              if (documents[0].passport !== null) {
                this.tabs.push({ name: 'Паспорт РФ', key: Math.random() })
              }
              setTimeout(() => {
                this.addPackageDataFromIdb(documents)
              }, 0)
            }
          }
        )
      }
      this.$nextTick(() => {
        this.$refs.houseShipmentPage[0].resetFormData()
        this.$refs.goodsPage[0].resetFormData()
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          this.$refs.waybillPage[0].resetFormData()
        }
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          this.$refs.inventoryPage[0].resetFormData()
        }
        if (this.$refs.airWaybillPage && this.$refs.airWaybillPage.length > 0) {
          this.$refs.airWaybillPage[0].resetFormData()
        }
        this.$refs.observer.reset()
      })
      if (this.$route.name === 'EditHouseShipment') {
        this.getPackageDocumentsList(this.$route.params.pid).then(
          () => {
            if (!this.isEditedAsNewPackage()) {
              this.notForEdit = this.isPackageNotForEdit()
            }
            if (this.isNewPackageInChain() || this.isEditedAsNewPackage()) {
              this.setPackagePid(null)
            }
            if (this.isEditedAsNewPackage()) {
              this.setPackageChainid(null)
              this.setPackageStatus(null)
            }
            idbapi.getPackageData().then(
              (documents) => {
                if (documents && (documents.length > 0)) {
                  if (documents[0].waybill !== null) {
                    this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
                  }
                  if (documents[0].freeBinaryDocs !== null) {
                    this.tabs.push({ name: 'Графические материалы', key: Math.random() })
                  }
                  if (documents[0].passport !== null) {
                    this.tabs.push({ name: 'Паспорт РФ', key: Math.random() })
                  }
                  setTimeout(() => {
                    this.addPackageDataFromIdb(documents)
                  }, 200)
                } else {
                  this.getDocuments()
                }
              }
            )
          },
          (error) => {
            console.log(error)
          }
        )
      }
      this.$watch(
        () => {
          return this.$refs.houseShipmentPage[0].houseShipmentForm.Transport_ModeCode
        },
        (val) => {
          this.TransportModeCode = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.houseShipmentPage[0].houseShipmentForm.Transport_DocumentNumber
        },
        (val) => {
          this.TransportDocumentNumber = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.houseShipmentPage[0].houseShipmentForm.HouseWaybill_ModeCode
        },
        (val) => {
          this.HouseWaybillModeCode = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.houseShipmentPage[0].houseShipmentForm.HouseWaybill_DocumentNumber
        },
        (val) => {
          this.HouseWaybillDocumentNumber = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.houseShipmentPage[0].houseShipmentForm.Consignor_Name
        },
        (val) => {
          this.ConsignorName = val
        }
      )
      this.$watch(
        () => {
          return this.$refs.houseShipmentPage[0].houseShipmentForm.Consignee_Name
        },
        (val) => {
          this.ConsigneeName = val
        }
      )
    },
    computed: {
      ...mapState(
        {
          houseShipment: state => state.houseShipment.package,
          packagePid: state => state.houseShipment.packagePid,
          packageChainid: state => state.houseShipment.packageChainid,
          packageStatus: state => state.houseShipment.packageStatus,
          declineReasons: state => state.packages.declineReasons || JSON.parse(localStorage.getItem('decline_reasons')),
          nsiCountries: state => state.commissionShipment.nsiCountries,
          packageDocumentsList: state => state.houseShipment.packageDocumentsList,
          waybill: state => state.houseShipment.waybill,
          userInfo: state => state.authorization.userInfo,
          freeBinaryDocs: state => state.houseShipment.freeBinaryDocs,
          passport: state => state.houseShipment.passport,
          airWaybill: state => state.houseShipment.airWaybill,
        }
      ),
      hasEmptyRequiredFields(){
        if (!this.TransportModeCode || 
            !this.TransportDocumentNumber) return true
        else return false
      },
    },
    methods: {
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      closeRefs () {
        for (const item in this.$refs.houseShipmentPage[0].houseShipmentForm) {
          if (this.$refs.houseShipmentPage[0].$refs[item] && this.$refs.houseShipmentPage[0].$refs[item].items) {
            this.$refs.houseShipmentPage[0].$refs[item].items = []
          }
        }
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          for (const item in this.$refs.waybillPage[0].waybillForm) {
            if (this.$refs.waybillPage[0].$refs[item] && this.$refs.waybillPage[0].$refs[item].items) {
                this.$refs.waybillPage[0].$refs[item].items = []
            }
          }
        }
        if (this.$refs.passportPage && this.$refs.passportPage.length > 0) {
          for (const item in this.$refs.passportPage[0].passportForm) {
            if (this.$refs.passportPage[0].$refs[item] && this.$refs.passportPage[0].$refs[item].items) {
                this.$refs.passportPage[0].$refs[item].items = []
            }
          }
        }
        if (this.$refs.airWaybillPage && this.$refs.airWaybillPage.length > 0) {
          for (const item in this.$refs.airWaybillPage[0].passportForm) {
            if (this.$refs.airWaybillPage[0].$refs[item] && this.$refs.airWaybillPage[0].$refs[item].items) {
                this.$refs.airWaybillPage[0].$refs[item].items = []
            }
          }
        }
      },
      addPassportPage () {
        this.tabs.push({ name: 'Паспорт РФ', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          document.activeElement.blur()
          this.savePackageInIdb()
        }, 200)
      },
      addWaybillPage () {
        this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          document.activeElement.blur()
          this.savePackageInIdb()
        }, 200)
      },
      addInventoryPage () {
        this.tabs.push({ name: 'Графические материалы', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          document.activeElement.blur()
          this.savePackageInIdb()
          this.$refs.inventoryPage[0].inventoryForm.data.push(
              {
                key: Math.random(),
                file: null,
                FileName: 'Файл не выбран',
                did: null,
                DOC_ID: null,
                ModeCode: '09023', // Код документа
                DocName: null, // Наименование документа
                RegNum: null, // Номер документа
                RegDate: null, // Дата документа
                FileData: null,
              }
            )
        }, 200)
      },
      addAirWaybillPage () {
        this.tabs.push({ name: 'Авианакладная', key: Math.random() })
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          document.activeElement.blur()
          this.savePackageInIdb()
        }, 200)
      },
      removeDoc (docName) {
        switch (docName) {
          case 'Паспорт РФ':
            this.removePassportPage()
            break
          case 'Индивидуальная накладная':
            this.removeWaybillPage()
            break
          case 'Графические материалы':
            this.removeInventoryPage()
            break
          case 'Авианакладная':
            this.removeAirWaybillPage()
            break

        }
      },
      removeWaybillPage () {
        this.tabs.splice(this.tabs.findIndex(x => x.name === 'Индивидуальная накладная'), 1)
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          this.savePackageInIdb()
        }, 200)
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          if (this.$refs.waybillPage[0].waybillForm.did) {
            this.deleteWaybill({
              pid: this.$route.params.pid,
              did: this.$refs.waybillPage[0].waybillForm.did
            }).then(
              () => {
                this.$refs.waybillPage[0].resetFormData()
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      },
      removeInventoryPage () {
        this.tabs.splice(this.tabs.findIndex(x => x.name === 'Графические материалы'), 1)
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          this.savePackageInIdb()
        }, 200)
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          this.$refs.inventoryPage[0].inventoryForm.data.forEach(doc => {
            if (doc.did) this.deleteFreeBinaryDoc({ pid: this.$route.params.pid, did: doc.did })
          })
          this.$refs.inventoryPage[0].resetFormData()
        }
      },
      removePassportPage () {
        this.tabs.splice(this.tabs.findIndex(x => x.name === 'Паспорт РФ'), 1)
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          this.savePackageInIdb()
        }, 200)
        if (this.$refs.passportPage && this.$refs.passportPage.length > 0) {
          if (this.$refs.passportPage[0].passportForm.did) {
            this.deletePassport({
              pid: this.$route.params.pid,
              did: this.$refs.passportPage[0].passportForm.did
            }).then(
              () => {
                this.$refs.passportPage[0].resetFormData()
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      },
      removeAirWaybillPage () {
        this.tabs.splice(this.tabs.findIndex(x => x.name === 'Авианакладная'), 1)
        setTimeout(() => {
          this.tabIndex = this.tabs.length-1
          this.savePackageInIdb()
        }, 200)
        if (this.$refs.airWaybillPage && this.$refs.airWaybillPage.length > 0) {
          if (this.$refs.airWaybillPage[0].airWaybillForm.did) {
            this.deleteAirWaybill({
              pid: this.$route.params.pid,
              did: this.$refs.airWaybillPage[0].airWaybillForm.did
            }).then(
              () => {
                this.$refs.airWaybillPage[0].resetFormData()
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      },
      hasTab (itemName) {
        return this.tabs.some(e => e.name === itemName)
      },
      isPackageNotForEdit () {
         let notForEdit = [4, 730, 731, 754, 0, 6].find((item) => {
           return item === parseInt(this.packageStatus)
         })
        return notForEdit === undefined
      },
      isEditedAsNewPackage () {
        return (this.$route.query.new === 'true')
      },
      isNewPackageInChain () {
        const isNewPackageInChain = [4, 730, 731, 754, 0, 6].find((item) => {
          return item === parseInt(this.packageStatus)
        })
        return !!isNewPackageInChain
      },
      scrollIfError () {
        this.$refs.observer.validate()
        setTimeout(() => {
          const fieldsWithErrors = this.$refs.observer.errors
          let fieldsNames = []
          for (const property in fieldsWithErrors) {
            if (fieldsWithErrors[property].length > 0) {
              fieldsNames.push(property)
            }
          }
          if (fieldsNames.length > 0) {
            fieldsNames = fieldsNames.join(', ')
            this.$bvToast.toast('Заполните: ' + fieldsNames + '!', {
              title: 'Не заполнено обязательное поле',
              toaster: 'b-toaster-bottom-right',
              solid: true,
              appendToast: true,
              noAutoHide: true
            })
          } else {
            this.sendToFts()
          }
        }, 500)
      },
      getValidationState ({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null
      },
      sendToPortal () {
        this.showConfirmModal = true
        this.savePackage()
      },
      sendToFts () {
        this.savePackage().then(
          () => {
            this.sendPackageFts(this.$route.params.pid).then(
              () => {
                this.$router.push('/ecr/house-shipment')
              },
              error => {
                console.log(error)
              }
            )
          },
          error => {
            console.log(error)
          }
        )
      },
      getPackagePid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && this.isNewPackageInChain() && (this.$route.name === 'EditHouseShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditHouseShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditHouseShipment') && !this.isEditedAsNewPackage()) {
          return parseInt(this.$route.params.pid)
        }
        // новый пакет на основании предыдущего
        if (this.isEditedAsNewPackage()) {
          return null
        }
      },
      getPackageChanid () {
        // новый пакет в цепочке
        if ((this.packagePid === null) && this.isNewPackageInChain() && (this.$route.name === 'EditHouseShipment') && !this.isEditedAsNewPackage()) {
          return this.packageChainid
        }
        // новый пакет
        if ((this.packagePid === null) && (this.packageStatus === null) && !(this.$route.name === 'EditHouseShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // текущий пакет
        if ((this.packagePid !== null) && (this.$route.name === 'EditHouseShipment') && !this.isEditedAsNewPackage()) {
          return null
        }
        // новый пакет на основании предыдущего
        if (this.isEditedAsNewPackage()) {
          return null
        }
      },
      addPackageDataFromIdb (documents) {
        this.idbPackageId = documents[0].id
        this.setPackage({
          data: {
            data: documents[0].houseShipment,
            did: documents[0].houseShipment.did
          }
        })
        if (documents[0].waybill !== null) {
          this.setWaybill({ data: { data: documents[0].waybill, did: documents[0].waybill.did } })
        }
        if (documents[0].freeBinaryDocs !== null) {
          this.setFreeBinaryDocs(documents[0].freeBinaryDocs)
        }
        if (documents[0].passport !== null) {
          this.setPassport({ data: { data: documents[0].passport, did: documents[0].passport.did } })
        }
        if (documents[0].airWaybill !== null) {
          this.setAirWaybill({ data: { data: documents[0].airWaybill, did: documents[0].airWaybill.did } })
        }
      },
      deletePackageFromIdb () {
        idbapi.deletePackageData(this.idbPackageId)
        this.$refs['get-packages-from-cache'].hide()
        this.$router.push({ name: this.preventedRouteTo })
      },
      savePackageInIdb () {
        const houseShipmentData = Object.assign({}, this.$refs.houseShipmentPage[0].houseShipmentForm,
          { GOODS: this.$refs.goodsPage[0].GOODS },
          { TotalGoodsNumber : this.$refs.goodsPage[0].TotalGoodsNumber },
          { TotalWaybillGrossWeightQuantity : this.$refs.goodsPage[0].TotalWaybillGrossWeightQuantity },
          { TotalWaybillAmount: this.$refs.goodsPage[0].TotalWaybillAmount },
          { TotalWaybillCurrencyCode: this.$refs.goodsPage[0].TotalWaybillCurrencyCode },
          { TotalWaybillCurrencyCodeABR: this.$refs.goodsPage[0].TotalWaybillCurrencyCodeABR },
          { TotalWaybillCustomsCost: this.$refs.goodsPage[0].TotalWaybillCustomsCost },
          { TotalWaybillCustomsCurrencyCodeABR: this.$refs.goodsPage[0].TotalWaybillCustomsCurrencyCodeABR },
          { TotalWaybillCustomsCurrencyCode: this.$refs.goodsPage[0].TotalWaybillCustomsCurrencyCode }
        )
        let docsData = null
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          docsData = this.$refs.inventoryPage[0].inventoryForm.data
        }
        let waybillData = null
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          waybillData = this.$refs.waybillPage[0].waybillForm
        }
        let passportData = null
        if (this.$refs.passportPage && this.$refs.passportPage.length > 0) {
          passportData = this.$refs.passportPage[0].passportForm
        }
        let airWaybillData = null
        if (this.$refs.airWaybillPage && this.$refs.airWaybillPage.length > 0) {
          airWaybillData = this.$refs.airWaybillPage[0].airWaybillForm
        }
        //узел PRESENTEDDOC
        if (this.$refs.goodsPage[0].GOODS && this.$refs.goodsPage[0].GOODS.GOODS_ITEM && this.$refs.goodsPage[0].GOODS.GOODS_ITEM.length > 0) {
          this.$refs.goodsPage[0].GOODS.GOODS_ITEM.map((item) => { 
            this.$nextTick(() => {
              item.PRESENTEDDOC = {}
              item.PRESENTEDDOC.PRESENTEDDOC_ITEM = []
              if (waybillData) {
                this.$refs.waybillPage[0].waybillForm.WBEIGOODS.WBEIGOODS_ITEM = []
                this.$refs.waybillPage[0].waybillForm.WBEIGOODS.WBEIGOODS_ITEM.push({
                  DOC_ID: item.DOC_ID,
                  Receiver_Name: this.$refs.houseShipmentPage[0].houseShipmentForm.Consignee_Name,
                  Receiver_INN: this.$refs.houseShipmentPage[0].houseShipmentForm.Consignee_INN,
                  CommonWayBillNum: this.$refs.houseShipmentPage[0].houseShipmentForm.Transport_DocumentNumber,
                  GoodsDescription: item.GoodsDescription,
                  TNVEDCode: item.GoodsCode,
                  NetWeightQuantity: item.NetWeightQuantity,
                  GrossWeightQuantity: item.GrossWeightQuantity,
                  InvoicedCost: item.CurrencyQuantity,
                  CustomsCost: item.CustomsCost,
                  Length: item.Length,
                  Width: item.Width,
                  Height: item.Height,
                  DimensionsCode: item.DimensionsCode,
                })
                item.PRESENTEDDOC.PRESENTEDDOC_ITEM.push({
                  ModeCode: '02021',
                  DocumentName: 'Индивидуальная накладная при экспресс-перевозке',
                  DocumentNumber: this.$refs.houseShipmentPage[0].houseShipmentForm.HouseWaybill_DocumentNumber,
                })
              }
              if (docsData) {
                docsData.map((doc) => {
                  item.PRESENTEDDOC.PRESENTEDDOC_ITEM.push({
                    ModeCode: doc.ModeCode,
                    DocumentName: doc.DocName,
                    DocumentNumber: doc.RegNum,
                    DocumentDate: doc.RegDate,
                  })
                })
              }
              if (passportData) {
                item.PRESENTEDDOC.PRESENTEDDOC_ITEM.push({
                  ModeCode: '11001',
                  DocumentName: 'Паспорт гражданина РФ',
                  DocumentNumber: [passportData.RegSeries, passportData.RegNum].join(' '),
                  DocumentDate: passportData.RegDate,
                })
              }
            })
          })
        }
        idbapi.updatePackageData({
          id: this.idbPackageId,
          houseShipment: houseShipmentData,
          freeBinaryDocs: docsData,
          waybill: waybillData,
          passport: passportData,
          airWaybill: airWaybillData,
          pid: (this.$route.params.pid) ? (this.$route.params.pid) : null,
          editedAsNew: this.isEditedAsNewPackage(),
          new: (this.$route.name === 'AddHouseShipment'),
          edited: (this.$route.name === 'EditHouseShipment'),
          type: 'houseshipment'
        })
      },
      savePackage () {
        return new Promise((resolve, reject) => {
        const payload = Object.assign(
          {},
          this.$refs.houseShipmentPage[0].houseShipmentForm,
          { GOODS: this.$refs.goodsPage[0].GOODS },
          { TotalGoodsNumber : this.$refs.goodsPage[0].TotalGoodsNumber },
          { TotalWaybillGrossWeightQuantity : this.$refs.goodsPage[0].TotalWaybillGrossWeightQuantity },
          { TotalWaybillAmount: this.$refs.goodsPage[0].TotalWaybillAmount },
          { TotalWaybillCurrencyCode: this.$refs.goodsPage[0].TotalWaybillCurrencyCode },
          { TotalWaybillCurrencyCodeABR: this.$refs.goodsPage[0].TotalWaybillCurrencyCodeABR },
          { TotalWaybillCustomsCost: this.$refs.goodsPage[0].TotalWaybillCustomsCost },
          { TotalWaybillCustomsCurrencyCodeABR: this.$refs.goodsPage[0].TotalWaybillCustomsCurrencyCodeABR },
          { TotalWaybillCustomsCurrencyCode: this.$refs.goodsPage[0].TotalWaybillCustomsCurrencyCode }
        )
        let waybillData = null
        if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
          waybillData = this.$refs.waybillPage[0].waybillForm
        }
        let docsData = null
        if (this.$refs.inventoryPage && this.$refs.inventoryPage.length > 0) {
          docsData = this.$refs.inventoryPage[0].inventoryForm.data
        }
        let passportData = null
        if (this.$refs.passportPage && this.$refs.passportPage.length > 0) {
          passportData = this.$refs.passportPage[0].passportForm
        }
        let airWaybillData = null
        if (this.$refs.airWaybillPage && this.$refs.airWaybillPage.length > 0) {
          airWaybillData = this.$refs.airWaybillPage[0].airWaybillForm
        }
        //узел PRESENTEDDOC
        if (this.$refs.goodsPage[0].GOODS && this.$refs.goodsPage[0].GOODS.GOODS_ITEM && this.$refs.goodsPage[0].GOODS.GOODS_ITEM.length > 0) {
          this.$refs.goodsPage[0].GOODS.GOODS_ITEM.map((item) => { 
            this.$nextTick(() => {
              item.PRESENTEDDOC.PRESENTEDDOC_ITEM = []
              if (waybillData) {
                this.$refs.waybillPage[0].waybillForm.WBEIGOODS.WBEIGOODS_ITEM = []
                this.$refs.waybillPage[0].waybillForm.WBEIGOODS.WBEIGOODS_ITEM.push({
                  DOC_ID: item.DOC_ID,
                  Receiver_Name: this.$refs.houseShipmentPage[0].houseShipmentForm.Consignee_Name,
                  Receiver_INN: this.$refs.houseShipmentPage[0].houseShipmentForm.Consignee_INN,
                  CommonWayBillNum: this.$refs.houseShipmentPage[0].houseShipmentForm.Transport_DocumentNumber,
                  GoodsDescription: item.GoodsDescription,
                  TNVEDCode: item.GoodsCode,
                  NetWeightQuantity: item.NetWeightQuantity,
                  GrossWeightQuantity: item.GrossWeightQuantity,
                  InvoicedCost: item.CurrencyQuantity,
                  CustomsCost: item.CustomsCost,
                  Length: item.Length,
                  Width: item.Width,
                  Height: item.Height,
                  DimensionsCode: item.DimensionsCode,
                })
                item.PRESENTEDDOC.PRESENTEDDOC_ITEM.push({
                  ModeCode: '02021',
                  DocumentName: 'Индивидуальная накладная при экспресс-перевозке',
                  DocumentNumber: this.$refs.houseShipmentPage[0].houseShipmentForm.HouseWaybill_DocumentNumber,
                })
              }
              if (docsData) {
                docsData.map((doc) => {
                  item.PRESENTEDDOC.PRESENTEDDOC_ITEM.push({
                    ModeCode: doc.ModeCode,
                    DocumentName: doc.DocName,
                    DocumentNumber: doc.RegNum,
                    DocumentDate: doc.RegDate,
                  })
                })
              }
              if (passportData) {
                item.PRESENTEDDOC.PRESENTEDDOC_ITEM.push({
                  ModeCode: '11001',
                  DocumentName: 'Паспорт гражданина РФ',
                  DocumentNumber: [passportData.RegSeries, passportData.RegNum].join(' '),
                  DocumentDate: passportData.RegDate,
                })
              }
            })
          })
        }
          this.saveHouseShipment(payload).then(
            () => {
              if (this.$refs.waybillPage && this.$refs.waybillPage.length > 0) {
                this.saveWaybill(waybillData).then(
                  () => {
                    resolve()
                  },
                  (error) => {
                    reject(error)
                  }
                )
              }
              if (docsData) {
                this.saveFreeBinaryDocList(docsData).then(
                  () => {
                    resolve()
                  },
                  (error) => {
                    reject(error)
                  }
                )
              }
              if (passportData) {
                this.savePassport(passportData).then(
                  () => {
                    resolve()
                  },
                  (error) => {
                    reject(error)
                  }
                )
              }
              if (airWaybillData) {
                this.saveAirWaybill(airWaybillData).then(
                  () => {
                    resolve()
                  },
                  (error) => {
                    reject(error)
                  }
                )
              }
              if (this.showConfirmModal) this.$refs['save-package-result-modal'].show()
              resolve()
            },
            (error) => {
              reject(error)
            }
          )
          idbapi.deletePackageData(this.idbPackageId)
        })
      },
      saveHouseShipment (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.houseShipmentPage[0].houseShipmentForm.did === null) {
            this.createHouseShipment({
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              data
            }).then(
              (result) => {
                this.$refs.houseShipmentPage[0].houseShipmentForm.did = result.did
                if ((this.$route.name === 'AddHouseShipment') || ((this.$route.name === 'EditHouseShipment') && this.isNewPackageInChain()) || ((this.$route.name === 'EditHouseShipment') && this.isEditedAsNewPackage())) {
                  this.$router.push(`/ecr/house-shipment/${this.packagePid}`)
                }
                resolve()
              },
              error => {
                reject(error)
              }
            )
          } else {
            this.editHouseShipment({
              pid: this.getPackagePid(),
              chainid: this.getPackageChanid(),
              data
            }).then(
              () => {
                resolve()
              },
              error => {
                reject(error)
              }
            )
          }
        })
      },
      saveWaybill (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.waybillPage[0].waybillForm.did === null) {
            this.createWaybill({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                (result) => {
                  this.$refs.waybillPage[0].waybillForm.did = result.did
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
          } else {
            this.editWaybill({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                () => {
                  resolve()
                },
                error => {
                  reject(error)
                }
              )
            }
        })
      },
      async saveFreeBinaryDocList (data) {
        for (let i = 0; i < data.length; i++) {
          const freeBinaryDocData = {
            pid: this.getPackagePid(),
            chainid: this.getPackageChanid(),
            did: null,
            data: data[i]
          }
          if (data[i].did) {
            freeBinaryDocData.did = data[i].did
            await this.editFreeBinaryDoc(freeBinaryDocData)
          } else {
            await this.createFreeBinaryDoc(freeBinaryDocData).then(
              (result) => {
                data[i].did = result.did
              },
              (error) => {
                console.log(error)
              }
            )
          }
        }
      },
      savePassport (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.passportPage[0].passportForm.did === null) {
            this.createPassport({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                (result) => {
                  this.$refs.passportPage[0].passportForm.did = result.did
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
          } else {
            this.editPassport({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                () => {
                  resolve()
                },
                error => {
                  reject(error)
                }
              )
            }
        })
      },
      saveAirWaybill (data) {
        return new Promise((resolve, reject) => {
          if (this.$refs.airWaybillPage[0].airWaybillForm.did === null) {
            this.createAirWaybill({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                (result) => {
                  this.$refs.airWaybillPage[0].airWaybillForm.did = result.did
                  resolve()
                },
                (error) => {
                  reject(error)
                }
              )
          } else {
            this.editAirWaybill({ pid: this.getPackagePid(), chainid: this.getPackageChanid(), data: data }).then(
                () => {
                  resolve()
                },
                error => {
                  reject(error)
                }
              )
            }
        })
      },
      hideModal () {
        this.showConfirmModal = false
        if (this.$route.name !== 'EditHouseShipment') {
          this.$router.push(`/house-shipment/edit/${this.packagePid}`)
        }
        if (this.$route.name === 'EditHouseShipment') {
          this.getPackageDocumentsList(this.$route.params.pid).then(
            () => {
              if (this.isNewPackageInChain() || this.isEditedAsNewPackage()) {
                this.setPackagePid(null)
              }
              this.getDocuments()
            },
            (error) => {
              console.log(error)
            }
          )
        }
      },
      checkoutToEditHouseShipment () {
        this.$refs['save-package-result-modal'].hide()
      },
      async getDocuments () {
        function compare (a, b) {
          if (a.type < b.type) return -1
          if (a.type > b.type) return 1
          return 0
        }

        this.packageDocumentsList.sort(compare)
        for (let i = 0; i < this.packageDocumentsList.length; i++) {
          switch (this.packageDocumentsList[i].type.toLowerCase()) {
            case 'houseshipmentptd.cfg.xml':
              await this.getPackageByPid({
                 pid: this.$route.params.pid,
                 new: this.isEditedAsNewPackage()
               })
              break
            case 'wbei.cfg.xml':
              if (!this.hasTabName('Индивидуальная накладная')) {
                this.tabs.push({ name: 'Индивидуальная накладная', key: Math.random() })
              }
              await this.getWaybillByPid({ pid: this.$route.params.pid, new: this.isEditedAsNewPackage() })
              break
            case 'passportrf.cfg.xml':
              if (!this.hasTabName('Паспорт РФ')) {
                this.tabs.push({ name: 'Паспорт РФ', key: Math.random() })
              }
              await this.getPassportByPid({ pid: this.$route.params.pid, new: this.isEditedAsNewPackage() })
              break
            case 'freebinarydoc.cfg.xml':
              if (!this.hasTabName('Графические материалы')) {
                this.tabs.push({ name: 'Графические материалы', key: Math.random() })
              }
              await this.getFreeBinaryDoc({
                pid: this.$route.params.pid,
                did: this.packageDocumentsList[i].did,
                new: this.isEditedAsNewPackage()
              })
              break
            case 'airwaybill.cfg.xml':
              if (!this.hasTabName('Авианакладная')) {
                this.tabs.push({ name: 'Авианакладная', key: Math.random() })
              }
              await this.getAirWaybillByPid({ pid: this.$route.params.pid, new: this.isEditedAsNewPackage() })
              break
          }
        }
      },
      hasTabName (tabName) {
        const hasTabName = this.tabs.find((item) => {
          return item.name === tabName
        })
        return !!hasTabName
      },
      isTab (name) {
        return name === 'Паспорт РФ' || name === 'Индивидуальная накладная' || name === 'Графические материалы' || name === 'Авианакладная'
      },
      updateHsFields(item) {
        if (item && this.$refs.houseShipmentPage) {
          const key = Object.keys(item)[0]
          const val = Object.values(item)[0]
          this.$refs.houseShipmentPage[0].houseShipmentForm[key] = val
          if (Object.keys(item)[1]) this.$refs.houseShipmentPage[0].$refs[key].model = val
        }
      },
      updateWbFields (item) {
        if (item && this.$refs.waybillPage) {
          const key = Object.keys(item)[0]
          const val = Object.values(item)[0]
          this.$refs.waybillPage[0].waybillForm[key] = val
          if (Object.keys(item)[1]) this.$refs.waybillPage[0].$refs[key].model = val
        }
      },
      updatePassFields(item) {
        if (item && this.$refs.passportPage) {
          const key = Object.keys(item)[0]
          const val = Object.values(item)[0]
          this.$refs.passportPage[0].passportForm[key] = val
          if (Object.keys(item)[1]) this.$refs.passportPage[0].$refs[key].model = val
        }
      },
      ...mapActions({
        createHouseShipment: 'houseShipment/createHouseShipment',
        editHouseShipment: 'houseShipment/editHouseShipment',
        getPackageByPid: 'houseShipment/getPackageByPid',
        sendPackageFts: 'houseShipment/sendPackageFts',
        loadNsiCountries: 'commissionShipment/loadNsiCountries',
        getPackageDocumentsList: 'houseShipment/getPackageDocumentsList',
        getWaybillByPid: 'houseShipment/getWaybillByPid',
        createWaybill: 'houseShipment/createWaybill',
        editWaybill: 'houseShipment/editWaybill',
        deleteWaybill: 'houseShipment/deleteWaybill',
        getFreeBinaryDoc: 'houseShipment/getFreeBinaryDoc',
        deleteFreeBinaryDoc: 'houseShipment/deleteFreeBinaryDoc',
        createFreeBinaryDoc: 'houseShipment/createFreeBinaryDoc',
        editFreeBinaryDoc: 'houseShipment/editFreeBinaryDoc',
        getPassportByPid: 'houseShipment/getPassportByPid',
        createPassport: 'houseShipment/createPassport',
        editPassport: 'houseShipment/editPassport',
        deletePassport: 'houseShipment/deletePassport',
        getAirWaybillByPid: 'houseShipment/getAirWaybillByPid',
        createAirWaybill: 'houseShipment/createAirWaybill',
        editAirWaybill: 'houseShipment/editAirWaybill',
        deleteAirWaybill: 'houseShipment/deleteAirWaybill',
      }),
      ...mapMutations({
        setPackage: 'houseShipment/setPackage',
        setPackagePid: 'houseShipment/setPackagePid',
        setPackageChainid: 'houseShipment/setPackageChainid',
        setPackageStatus: 'houseShipment/setPackageStatus',
        setNsiCountries: 'commissionShipment/setNsiCountries',
        setPackageDocumentsList: 'houseShipment/setPackageDocumentsList',
        setWaybill: 'houseShipment/setWaybill',
        setFreeBinaryDoc: 'houseShipment/setFreeBinaryDoc',
        setFreeBinaryDocs: 'houseShipment/setFreeBinaryDocs',
        setPassport: 'houseShipment/setPassport',
        setAirWaybill: 'houseShipment/setAirWaybill',
      }),
    },
    beforeDestroy () {
      this.setPackage(null)
      this.setPackagePid(null)
      this.setPackageChainid(null)
      this.setPackageStatus(null)
      this.setPackageDocumentsList(null)
      this.setWaybill(null)
      this.setAirWaybill(null)
      this.setPassport(null)
      this.setFreeBinaryDocs(null)
      localStorage.removeItem('decline_reasons')
      this.notForEdit = false
    }
  }
</script>

<style lang="scss" scoped>
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }

  .close-ref {
    height: 100%;
    width: 100%;
    z-index: 1;
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: transparent;
    /* background-color: #989fa4; */
  }
</style>
